module.exports = __webpack_public_path__ + "static/persona-home-72bddd400108581769fcd84d19dc0470.png";